import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'

import { HeaderOnlyLayoutComponent } from './header-only-layout.component'
import { HeaderLeftNavLayout } from './header-left-nav-layout.component'
import { SplitView } from './split-view.component'
import { NavBarModule } from '../nav-bar/nav-bar.module'
import { MatSidenavModule } from '@angular/material/sidenav'


@NgModule({
  declarations: [
    HeaderLeftNavLayout,
    HeaderOnlyLayoutComponent,
    SplitView,
  ],
  imports: [
    CommonModule,
    RouterModule,
    BsDropdownModule,
    NavBarModule,
    MatSidenavModule,
  ],
  providers: [],
  exports: [
    HeaderLeftNavLayout,
    HeaderOnlyLayoutComponent,
    SplitView
  ],
})
export class LayoutModule {}
export default LayoutModule
